import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import '../css/AddUnit.css';

const AddUnit = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  const [unitName, setUnitName] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [toast, setToast] = useState({ show: false, message: '', type: '' });
  const [isEditMode, setIsEditMode] = useState(false);
  const API_URL = process.env.REACT_APP_API_URL;

  const showToast = (message, type = 'success') => {
    setToast({ show: true, message, type });
    setTimeout(() => {
      setToast({ show: false, message: '', type: '' });
    }, 3000);
  };

  useEffect(() => {
    console.log('Current URL params:', { id, pathname: location.pathname });
    if (location.pathname.includes('/edit-unit/') && id) {
      setIsEditMode(true);
      if (location.state && location.state.unit) {
        setUnitName(location.state.unit.unitname);
      } else {
        fetchUnitData();
      }
    } else {
      setIsEditMode(false);
      setUnitName('');
    }
  }, [id, location.pathname, location.state]);

  const fetchUnitData = async () => {
    try {
      const response = await fetch(`${API_URL}get-unit.php?id=${id}`);
      const data = await response.json();
      if (data.unit) {
        setUnitName(data.unit.unitname);
      }
    } catch (error) {
      showToast('Error loading unit data', 'error');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!unitName.trim()) {
      showToast('Please enter a unit name', 'error');
      return;
    }

    setIsSubmitting(true);

    try {
      const formData = new FormData();
      formData.append('unitname', unitName);

      let apiUrl = `${API_URL}add-unit-api.php`;
      if (isEditMode) {
        apiUrl = `${API_URL}edit-unit-api.php`;
        formData.append('unit_id', id);
      }

      const response = await fetch(apiUrl, {
        method: 'POST',
        body: formData,
      });

      const data = await response.json();

      if (response.ok && data.message && data.message.toLowerCase().includes('success')) {
        showToast(data.message, 'success');
        if (!isEditMode) {
          setUnitName('');
        }
        setTimeout(() => {
          navigate('/unit-list');
        }, 1500);
      } else {
        showToast(data.message || `Error ${isEditMode ? 'updating' : 'adding'} unit. Please try again.`, 'error');
      }
    } catch (error) {
      showToast(`Error ${isEditMode ? 'updating' : 'adding'} unit. Please try again.`, 'error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="add-unit-content">
      <div className="page-header" style={{display: 'block'}}>
        <h1>{isEditMode ? 'Edit Unit' : 'Add Unit'}</h1>
        <p>{isEditMode ? 'Update unit information' : 'Create a new unit for your system'}</p>
      </div>

      <div className="form-container">
        <form onSubmit={handleSubmit} className="add-unit-form">
          <div className="form-group">
            <label htmlFor="unitName">Unit Name</label>
            <input
              type="text"
              id="unitName"
              name="unitName"
              value={unitName}
              onChange={(e) => setUnitName(e.target.value)}
              placeholder="Enter unit name (e.g., kg, pcs, liters)"
              required
              disabled={isSubmitting}
            />
          </div>

          <button 
            type="submit" 
            className="submit-btn"
            disabled={isSubmitting}
          >
            {isSubmitting ? (isEditMode ? 'Updating Unit...' : 'Adding Unit...') : (isEditMode ? 'Update Unit' : 'Add Unit')}
          </button>
        </form>
      </div>

      {/* Toast Notification */}
      {toast.show && (
        <div className={`toast toast-${toast.type}`}>
          <div className="toast-content">
            <span className="toast-message">{toast.message}</span>
            <button 
              className="toast-close" 
              onClick={() => setToast({ show: false, message: '', type: '' })}
            >
              ×
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default AddUnit; 